import { configureStore } from '@reduxjs/toolkit';
import {
  dmAdminApiSlice,
  initSliceMeta as initDMAdminSliceMeta,
} from '@vs/rtk/slices/apiDmAdmin';
import {
  initSliceMeta as initAccount2SliceMeta,
  vsAccount2ApiSlice,
} from '@vs/rtk/slices/apiVsAccount2';
import {
  initSliceMeta as initAdminSliceMeta,
  vsAdminApiSlice,
} from '@vs/rtk/slices/apiVsAdmin';
import {
  initSliceMeta as initAuthSliceMeta,
  vsAuthApiSlice,
} from '@vs/rtk/slices/apiVsAuth';
import {
  initSliceMeta as initAuthAdminSliceMeta,
  vsAuthAdminApiSlice,
} from '@vs/rtk/slices/apiVsAuthAdmin';
import {
  initSliceMeta as initCommonSliceMeta,
  vsCommonApiSlice,
} from '@vs/rtk/slices/apiVsCommon';
import {
  initSliceMeta as initEntity2SliceMeta,
  vsEntity2ApiSlice,
} from '@vs/rtk/slices/apiVsEntity2';
import {
  initSliceMeta as initSubscriptionSliceMeta,
  vsSubscriptionApiSlice,
} from '@vs/rtk/slices/apiVsSubscription';
import { dispatchUnAuthErrorDialog } from '@vs/rtk/utils';

import { deployEnv, isLocalDevMode } from '../constants';
import { env } from '../constants/env';
import getUserAccessToken from '../utils/getUserAccessToken';
import { rootReducer } from './reducer';

const meta = {
  deployEnv,
  getTokenFunc: getUserAccessToken,
};
initAuthSliceMeta({ ...meta, baseUrl: env.apiEndpoint.vsAuth });
initCommonSliceMeta({ ...meta, baseUrl: env.apiEndpoint.vs });
initAccount2SliceMeta({ ...meta, baseUrl: env.apiEndpoint.vs });
initEntity2SliceMeta({
  ...meta,
  baseUrl: env.apiEndpoint.vs,
});
initAdminSliceMeta({ ...meta, baseUrl: env.apiEndpoint.vs });
initDMAdminSliceMeta({ ...meta, baseUrl: env.apiEndpoint.dmAdmin });
initAuthAdminSliceMeta({ ...meta, baseUrl: env.apiEndpoint.vsAdminAuth });
initSubscriptionSliceMeta({
  ...meta,
  env,
  baseUrl: env.apiEndpoint.vsSubscription,
});

export const store = configureStore({
  devTools: isLocalDevMode && { name: 'vs-admin-store' },
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat([
      vsAccount2ApiSlice.middleware,
      vsEntity2ApiSlice.middleware,
      vsAdminApiSlice.middleware,
      vsCommonApiSlice.middleware,
      vsAuthAdminApiSlice.middleware,
      vsSubscriptionApiSlice.middleware,
      dmAdminApiSlice.middleware,
      vsAuthApiSlice.middleware,
      dispatchUnAuthErrorDialog,
    ]),
});

if (isLocalDevMode && import.meta.hot) {
  import.meta.hot.accept('./reducer.ts', module =>
    store.replaceReducer(module?.rootReducer)
  );
}

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
